<template>
  <el-dialog :title="'編輯客服種類'" :visible.sync="isShowDialog">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-input v-model="event" placeholder="輸入客服種類" />
      </el-col>
      <el-col :span="12">
        <el-button
          type="primary"
          @click="onAddEvent"
          :loading="isAddBtnLoading"
        >
          新增
        </el-button>
      </el-col>
    </el-row>
    <table v-loading="isTableLoading" class="note-tab disable-select">
      <thead>
        <tr>
          <td>客服種類</td>
          <td>動作</td>
        </tr>
      </thead>
      <tbody
        is="draggable"
        v-model="typeList"
        element="tbody"
        :force-fallback="true"
        :scroll-sensitivity="200"
        ghost-class="ghost"
      >
        <tr v-for="(row, idx) in typeList" :key="row.id">
          <td>
            <el-input v-model="typeList[idx].name" />
          </td>
          <td>
            <el-button
              size="mini"
              @click="onRowEdit(idx, row)"
              :loading="isEditBtnLoading && idx === clickedEditBtnIdx"
            >
              更新
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="onRowDelete(idx, row)"
              :loading="isDeleteBtnLoading && idx === clickedDeleteBtnIdx"
            >
              刪除
            </el-button>
          </td>
        </tr>
      </tbody>
    </table>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="success"
        :loading="isSortBtnLoading"
        @click="updateTypePosition"
      >
        更新排序
      </el-button>
      <el-button type="default" @click="onClose">關閉</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  reqType,
  reqAddType,
  reqEditType,
  reqDeleteType,
} from '@/api/customerComplain'
import { cookies } from '@/utils/cookies'
import { mapMutations, mapActions, mapState } from 'vuex'
import { Notification } from 'element-ui'
import draggable from 'vuedraggable'

export default {
  components: { draggable },
  data() {
    return {
      typeList: [],
      event: '',
      isAddBtnLoading: false,
      isDeleteBtnLoading: false,
      clickedDeleteBtnIdx: null,
      isEditBtnLoading: false,
      clickedEditBtnIdx: null,
      isTableLoading: false,
      isSortBtnLoading: false,
    }
  },
  methods: {
    ...mapActions('managerStore', {}),
    ...mapMutations('managerStore', {
      vx_setIsAddEventDialog: 'SET_IS_ADD_EVENT_DIALOG',
      vx_setTypeList: 'SET_TYPE_LIST',
    }),
    async onAddEvent() {
      try {
        this.isAddBtnLoading = true
        const { success } = await reqAddType({
          name: this.event,
          customer_id: this.vx_currentLoginServiceId,
          service_name: cookies.get('GladName'),
          code: cookies.get('GladTeamCode'),
        })
        if (success) {
          this.event = ''
          Notification({
            type: 'success',
            message: '新增客訴事件成功',
          })
          this.updateTypeList()
        } else {
          Notification({
            type: 'error',
            message: '新增客訴事件失敗',
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '新增客訴事件失敗',
        })
      } finally {
        this.isAddBtnLoading = false
      }
    },
    async onRowEdit(idx, row) {
      try {
        this.isEditBtnLoading = true
        this.clickedEditBtnIdx = idx
        const { success } = await reqEditType(row.id, {
          name: row.name,
          customer_id: this.vx_currentLoginServiceId,
          service_name: cookies.get('GladName'),
          position: row.position,
        })
        if (success) {
          Notification({
            type: 'success',
            message: '更新客訴種類成功',
          })
          this.updateTypeList()
        } else {
          Notification({
            type: 'error',
            message: '更新客訴種類失敗',
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '更新客訴種類失敗',
        })
      } finally {
        this.isEditBtnLoading = false
        this.clickedEditBtnIdx = null
      }
    },
    async onRowDelete(idx, row) {
      try {
        this.isDeleteBtnLoading = true
        this.clickedDeleteBtnIdx = idx
        const { success } = await reqDeleteType(row.id, {
          customer_id: this.vx_currentLoginServiceId,
          service_name: cookies.get('GladName'),
        })
        if (success) {
          Notification({
            type: 'success',
            message: '刪除客訴種類成功',
          })
          this.updateTypeList()
        } else {
          Notification({
            type: 'error',
            message: '刪除客訴種類失敗',
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: '刪除客訴種類失敗',
        })
      } finally {
        this.isDeleteBtnLoading = false
        this.clickedDeleteBtnIdx = null
      }
    },
    onClose() {
      this.vx_setIsAddEventDialog(false)
    },
    async updateTypeList() {
      try {
        this.isTableLoading = true
        const { result } = await reqType(cookies.get('GladTeamCode'))
        /* 放入vuex時需要用position key進行排序 */
        this.vx_setTypeList(result.sort((a, b) => a.position - b.position))
      } catch (e) {
        console.error(e)
      } finally {
        this.isTableLoading = false
      }
    },
    async updateTypePosition() {
      try {
        this.isSortBtnLoading = true
        const updateTypeList = []
        for (let i = 0; i < this.typeList.length; i++) {
          const newType = this.typeList[i]
          const oldType = this.vx_typeList[i]
          if (
            newType.id !== oldType.id ||
            newType.position !== oldType.position
          ) {
            newType.position = i + 1
            updateTypeList.push(newType)
          }
        }
        const promises = updateTypeList.map(({ id, name, position }) =>
          reqEditType(id, {
            name: name,
            position: position,
            customer_id: this.vx_currentLoginServiceId,
            service_name: cookies.get('GladName'),
            code: cookies.get('GladTeamCode'),
          }),
        )
        const resArr = await Promise.all(promises)
        if (resArr.length) {
          Notification({ type: 'success', message: '更新排序成功' })
          this.updateTypeList()
        }
      } catch (e) {
        Notification({ type: 'error', message: '更新排序失敗' })
        console.error(e)
      } finally {
        this.isSortBtnLoading = false
      }
    },
  },
  computed: {
    ...mapState('managerStore', {
      vx_isAddEventDialog: 'isAddEventDialog',
      /* vx_driverList: 'driverList', */
      vx_typeList: 'typeList',
      vx_currentLoginServiceId: 'currentLoginServiceId',
    }),
    isShowDialog: {
      get() {
        return this.vx_isAddEventDialog
      },
      set(value) {
        this.vx_setIsAddEventDialog(value)
      },
    },
  },
  created() {
    this.unwatchTypeList = this.$store.watch(
      (state) => state.managerStore.typeList,
      (newTypeList) => {
        this.typeList = newTypeList
      },
    )
  },
  beforeDestroy() {
    this.unwatchTypeList()
  },
}
</script>

<style scoped>
.note-tab {
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  margin: 1rem auto;
}

.note-tab > tbody {
  height: 200px;
  overflow-y: scroll;
}

.note-tab tr,
.note-tab td {
  border: 1px solid black;
}

.note-tab tr:hover {
  cursor: grab;
}

.note-tab tr:active {
  cursor: grabbing;
}

.note-tab td {
  padding: 1rem;
}

.disable-select {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/components/AddEventDialog.vue